<div
  class="console-layout"
  [class.console-layout--collapsed]="sidebarCollapsed"
  [style.--console-sidebar-offset]="sidebarCollapsed ? 'var(--console-sidebar-collapsed)' : 'var(--console-sidebar-w)'"
>
  <header class="console-topbar">
    <div class="console-topbar__left">
      <button type="button" class="console-topbar__icon-btn console-topbar__menu" (click)="toggleMenu()" aria-label="Abrir menú">
        <ng-icon name="lucideMenu" size="18"></ng-icon>
      </button>
      <button
        type="button"
        class="console-topbar__icon-btn console-topbar__collapse"
        (click)="toggleSidebarCollapse()"
        aria-label="Colapsar barra lateral"
      >
        <ng-icon [name]="sidebarCollapsed ? 'lucideChevronRight' : 'lucideChevronLeft'" size="18"></ng-icon>
      </button>
      <a routerLink="/main" class="console-topbar__brand">
        <img class="console-topbar__logo" src="assets/image/logo.svg" alt="Epago" />
      </a>
    </div>
    <div class="console-topbar__right">
      <a class="console-topbar__text-link" [href]="docsUrl" target="_blank" rel="noopener noreferrer">Documentación</a>
    </div>
  </header>

  <aside class="console-sidebar" [class.console-sidebar--open]="isMenuOpen" [class.console-sidebar--collapsed]="sidebarCollapsed">
    <nav class="console-sidebar__nav">
      <div class="console-sidebar__group">
        <span class="console-sidebar__label">Pagos</span>
        <a class="console-sidebar__item" routerLink="/checkout2" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideCreditCard" size="18"></ng-icon><span class="console-sidebar__text">Checkout</span>
        </a>
        <a class="console-sidebar__item" routerLink="/checkout-react-qr" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideQrCode" size="18"></ng-icon><span class="console-sidebar__text">Checkout React QR</span>
        </a>
        <a class="console-sidebar__item" routerLink="/paylink" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideLink" size="18"></ng-icon><span class="console-sidebar__text">PayLink</span>
        </a>
        <a class="console-sidebar__item" routerLink="/sip-pay" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideSmartphone" size="18"></ng-icon><span class="console-sidebar__text">Pago con Sip</span>
        </a>
      </div>
      <div class="console-sidebar__group">
        <span class="console-sidebar__label">Tarjetas</span>
        <a class="console-sidebar__item" routerLink="/card-register" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideWalletCards" size="18"></ng-icon><span class="console-sidebar__text">Registro de tarjeta</span>
        </a>
        <a class="console-sidebar__item" routerLink="/saved-card-pay" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideNfc" size="18"></ng-icon><span class="console-sidebar__text">Pago tokenizado</span>
        </a>
      </div>
      <div class="console-sidebar__group">
        <span class="console-sidebar__label">Herramientas</span>
        <a class="console-sidebar__item" routerLink="/processor-benefit" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideLandmark" size="18"></ng-icon><span class="console-sidebar__text">Procesador Benefit</span>
        </a>
        <a class="console-sidebar__item" routerLink="/agora-simulator-control" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideActivity" size="18"></ng-icon><span class="console-sidebar__text">Control del simulador</span>
        </a>
        <a class="console-sidebar__item" routerLink="/izipay-generator" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideReceipt" size="18"></ng-icon><span class="console-sidebar__text">Generador por lote F5</span>
        </a>
        <a class="console-sidebar__item" routerLink="/estilos-inyectables" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucidePalette" size="18"></ng-icon><span class="console-sidebar__text">Estilos inyectables</span>
        </a>
        <a class="console-sidebar__item" routerLink="/ordenes" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideList" size="18"></ng-icon><span class="console-sidebar__text">Órdenes</span>
        </a>
      </div>
      <div class="console-sidebar__group">
        <span class="console-sidebar__label">Más</span>
        <a class="console-sidebar__item" routerLink="/vtex" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideShoppingBag" size="18"></ng-icon><span class="console-sidebar__text">VTEX</span>
        </a>
        <a class="console-sidebar__item" routerLink="/demo1" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideFlaskConical" size="18"></ng-icon><span class="console-sidebar__text">Demo FA</span>
        </a>
        <a class="console-sidebar__item" routerLink="/izipay-excel-generator" routerLinkActive="console-sidebar__item--active" (click)="onNavClick()">
          <ng-icon name="lucideTable" size="18"></ng-icon><span class="console-sidebar__text">Izipay Excel</span>
        </a>
      </div>
    </nav>
    <a class="console-sidebar__docs" [href]="docsUrl" target="_blank" rel="noopener noreferrer">
      <ng-icon name="lucideBookOpen" size="18"></ng-icon>
      <span class="console-sidebar__text">Documentación</span>
    </a>
  </aside>

  <div class="console-sidebar-backdrop" [class.console-sidebar-backdrop--visible]="isMenuOpen" (click)="closeMenu()"></div>

  <main class="console-main">
    <router-outlet></router-outlet>
  </main>
</div>
